import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { GlobalUserComponent } from './global-user/global-user.component';
import { CurrentUserService } from './shared/services/current-user.service';
import { EditionListService } from './editions/edition.service';
import { CurrentUser } from './models/current-user';
import { ApiService } from './root-services/api.service';


@Component({
  selector: 'app-nomadic-admin',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})

export class AppComponent implements OnInit {
  public searchResults: any = null;
  public email: string = null;
  public add: boolean = false;
  public accountSettings: boolean = false;
  public userObservable: Observable<CurrentUser>;
  @ViewChild(GlobalUserComponent) globalUser: GlobalUserComponent;

  constructor(
    private currentUserService: CurrentUserService,
    public apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private editionList: EditionListService
  ) {
    // Fetch identity of current admin user
    this.userObservable = this.currentUserService.getUserData();

    // Get edition ID from URL and store in local storage
    const searchParams = new URLSearchParams(window.location.search);
    const editionId = searchParams.get('edition');
    if (editionId) {
      localStorage.setItem('edition_id', editionId);
    }
  }

  public openDialogue(): void {
    this.add = true;
  }

  public resetData(): void {
    this.searchResults = null;
    this.email = null;
    this.add = false;
    this.globalUser.clearSearchBox();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/app.component.ts